import React from 'react';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import 'CSS/demand-supply/demand-supply.scss';

class DeleteDialog extends React.Component {
  render() {
    const { isDeactivate = false } = this.props;
    return (
      <Dialog
        maxWidth={'xs'}
        open={this.props.isOpen}
        onClose={this.props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>{!isDeactivate ? 'Approve' : 'Decline'}</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to {!isDeactivate ? 'approve' : 'decline'}{' '}
            this registration?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose}>Cancel</Button>
          <Button
            onClick={this.props.doDelete}
            variant="contained"
            color="primary"
          >
            {!isDeactivate ? 'Approve' : 'Decline'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default DeleteDialog;
